import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { takeUntil } from 'rxjs/operators';
import { ReelCategoryModel } from '../models/reel-categories.model';
import { ReelCategoriesService } from '../../../../../services/reel-categories.service';

@Component({
  selector: 'app-create-edit-reel-category',
  templateUrl: './create-edit-reel-category.component.html',
  styleUrls: ['./create-edit-reel-category.component.scss']
})
export class CreateEditReelCategoryComponent implements OnInit, OnDestroy {
	@Input() data: any = {};
	formGroup: RxFormGroup;

	fields: any = {
		title: {
			type: 'input',
			options: {
				path: 'title',
				class: 'col-sm-12',
				label: {
					text: 'Titulo',
					class: 'col-sm-12'
				}
			}
		},
		type: {
			type: 'select',
			options: {
				path: 'type',
				label: {
					text: 'Tipo de Reel'
				},
				dropdown: {
					text: 'Seleccione...',
					options: [
						{
							id: 'IMAGE',
							name: 'Imagen'
						},
						{
							id: 'VIDEO',
							name: 'Video'
						}
					]
				}
			}
		},
		category_id: {
			type: 'input',
			options: {
				path: 'category_id',
				class: 'col-sm-12',
				label: {
					text: 'Categoria de Reel',
					class: 'col-sm-12'
				}
			}
		}
	};

	private atComponentDestroy = new Subject();

	get isImageType(): boolean {
		return this.formGroup.get('type').value;
	}

	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private reelCategoriessService: ReelCategoriesService
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.formGroup = data;
			});
	}
	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		await this.formService.transformIntoFormGroup(ReelCategoryModel, this.data);

		this.formGroup.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.cdr.markForCheck();
			});
	}

	/**
	 * Send the data to the server
	 */
	submit(): void {
		this.reelCategoriessService.createOrUpdate(this.formGroup, this.data?.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				data => {
					this.broadcast.reloadDataTable();
					this.modalRef.hide();
				}
			);
	}

	/**
	 * Helper function to transform an Object into an Array
	 * @param enumme
	 * @returns
	 */
	toArray(enumme): any[] {
		return Object.keys(enumme)
			.map(key => ({ id: key, name: enumme[key] }));
	}

}
